import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import useAsync from '../hooks/useAsync';
import CouponServices from '../services/CouponServices';
import CouponUpdate from './Update Model/UpdateCoupon';
import ViewCoupon from './View Model/ViewCoupon';
import DeleteButton from './Button/DeleteButton';
import Modal from 'react-modal';
import ReactPaginate from 'react-paginate';
import Pagetitle from './PageTitle';
import * as XLSX from 'xlsx';
import { Link } from 'react-router-dom';

Modal.setAppElement('#root');

function CouponCode() {
  const { data, error, isLoading, run } = useAsync(CouponServices.getCoupon);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('');


  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [userTypeFilter, setUserTypeFilter] = useState('');
  const [planFilter, setPlanFilter] = useState('');

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState(data?.data || []);



  const couponPerPage = 10;
  const handleViewDetails = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };
  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
  };
  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };


  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  const handlePageClick = (data) => {
    setCurrentPage(data.selected + 1);
  };
  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'N/A';
    }
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
    return `${day}-${month}-${year}`;
  };

  const filteredCoupon = data?.data?.filter(coupon => {
    const matchesSearch = coupon?.name?.toLowerCase().includes(searchQuery?.toLowerCase() || "");
    const matchesStatus = statusFilter ? coupon?.status?.toLowerCase() === statusFilter?.toLowerCase() : true;
    return matchesSearch && matchesStatus;
  });




  // Calculate pagination values
  const indexOfLastUser = currentPage * couponPerPage;
  const indexOfFirstUser = indexOfLastUser - couponPerPage;
  const paginatedUsers = filteredCoupon?.slice(indexOfFirstUser, indexOfLastUser);  // Slice the filtered users for pagination

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box px-0 user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginBottom: "20px" }}>
        <div className="container-box-top-header px-4">
          <div className="container-box-top-header-left-2">
            <input
              type="search"
              name="search"
              placeholder="Search by Coupon Code"
              value={searchQuery}
              onChange={handleSearchChange}
            />
            <button className="search-btn">
              <FontAwesomeIcon icon={faSearch} />
            </button>
          </div>

          <div className="sub-title-box-right d-flex">
            <div>
              <select
                className="dropdown"
                value={statusFilter}
                onChange={handleStatusFilterChange}
              >
                <option value="">Coupon Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <Link className="Add-new-btn site-btn-green ms-3" to="/add-new-coupon-code">
              <img src="img/add-plus.svg" alt="" />
              <span className="ms-2">Add New</span>
            </Link>
          </div>
        </div>
        <div className="container-box-inner">
          <table id="example" className="table table-striped" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Image</th>
                <th>Coupon Code</th>
                <th>Discount</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Usage Limit</th>
                <th>Status</th>
                <th>Applied User</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedUsers?.map((coupon, index) => (
                <tr key={coupon?._id}>
                  <td>{index + 1 + (currentPage - 1) * couponPerPage}</td>
                  <td>
                    <img src={coupon?.image ? `${process.env.REACT_APP_URL}${coupon.image}` : 'img/profile-img.png'} alt="" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
                  </td>

                  <td style={{ maxWidth: '100px' }}>{coupon?.name ? coupon.name : 'N/A'}</td>
                  <td>{coupon?.discountType}</td>
                  <td>{formatDate(coupon?.startDate)}</td>
                  <td>{formatDate(coupon?.endDate)}</td>
                  <td>{coupon?.numberOfCoupons}</td>
                  <td className="reset-button" style={{
                    backgroundColor: coupon?.status === 'Active' ? '#699836' : '#232859',
                    color: '#fff'
                  }}>
                    {coupon?.status}
                  </td>
                  <td style={{ textAlign: 'center' }}> <a href='javascriptVoid:0'
                    onClick={() => handleViewDetails(coupon)}>{coupon?.appliedCoupon}</a>
                  </td>
                  <td>
                    <div className="action_toggle_outer">
                      <button className="action_toggle" onClick={() => toggleActionMenu(index)}>
                        <i className="fa fa-ellipsis-v" />
                      </button>
                      {activeIndex === index && (
                        <div className="action_toggle_content product-edit show d-block">
                          <ul className="list-unstyled">
                            <li>
                              <button className="close_toggle" onClick={() => toggleActionMenu(null)}>
                                <i className="fa fa-close" />
                              </button>
                            </li>
                            <li>
                              <button className="edit" style={{ backgroundColor: '#F98F42' }}
                                onClick={() => handleEditDetails(coupon)}>Edit</button>
                            </li>
                            <li>
                              <button className="reject" onClick={() => handleDelete(coupon)}>Delete</button>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}


            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="pagination">
          <ReactPaginate
            pageCount={Math.ceil((filteredCoupon?.length || 0) / couponPerPage)}
            pageRangeDisplayed={3}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            initialPage={currentPage - 1}
            disableInitialCallback={true}
            pageLinkClassName={'page-link'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            disabledClassName={'disabled'}
          />
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewCoupon coupon={selectedUser} closeModal={closeModal} />
      </Modal>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <CouponUpdate coupon={selectedEdit} closeModal={closeEditModal} onSuccess={run} />
      </Modal>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton data={selectedEdit} page="Coupon" closeModal={closeDeleteModal} onSuccess={run} />
      </Modal>
    </div>
  );
}

export default CouponCode;
